import "./events.css";
import "../home/home.css";
import EventTiles from "../../../components/page/event/event-tile/event.tile.component";
import { public_event_list } from "../public.api";

import React, { useEffect, useState } from "react";
import Loader from "../../../components/loader/loader";
import BreadCrumbsComp from "../../../components/navigator/breadcrumbs";
import moment from "moment";

export default function Events(props) {
  const [data, setData] = useState([]);
  const [url, setUrl] = useState("");
  const [isActive, setIsActive] = useState(true);
  let fromHome = sessionStorage.getItem("continueFrom");
   const lang = props.state?.language || "en";
   //console.log(lang)
  const fetchEvents = () => {
    public_event_list().then((res) => {
      const today = moment(); 
      const upcomingEvents = res.data.filter((event) => {
        const eventDateStr = event.en?.eventDate || event.ma?.eventDate;
        const eventDate = moment(eventDateStr, "DD-MM-YYYY");
        return eventDate.isSameOrAfter(today, "day");
      });

      setData(upcomingEvents);
      setUrl(res.current_url);
      setIsActive(false);
    });
  };
  useEffect(() => {
    fetchEvents();
  }, []);

  return (
    <>
      {fromHome === "events" && <BreadCrumbsComp section="home" />}
      <div>
        <Loader open={isActive} />
        <div>
          {/* ======================= Events  =================================================================== */}
          <div className="">
            <div
              className={
                fromHome === "events"
                  ? "header-banner-from-home "
                  : "header-banner"
              }
            >
              <div className="tit-txt">
                {props.state.language === "ma"
                  ? "വരാനിരിക്കുന്ന പരിപാടികൾ"
                  : "Upcoming Events "}
              </div>
            </div>
          </div>
          <div className="events-section">
            <div className="event-tile-container">
              {data?.length > 0 ? (
                data.map((item) => (
                  <EventTiles
                    key={item.id}
                    {...props}
                    data={item}
                    url={url}
                    isBookable={true}
                  />
                ))
              ) : (
                <div className="event-empty-state">
                  {props.state.language === "ma"
                    ? "പരിപാടികളൊന്നും ലഭ്യമല്ല"
                    : "No upcoming events right now. Please check back soon."}
                </div>
              )}
            </div>
          </div>
          {/* =================================================================================================== */}
        </div>
      </div>
    </>
  );
}
